import { type ReactElement, useCallback } from 'react';
import { Icon } from '@timeedit/ui-components';
import { Modal } from '@timeedit/ui-components/antd';

export type TConfirmDeleteFunc = (
  resourceName: string,
  onOk: () => void,
  okText?: string,
  cancelText?: string
) => void;

export const useDeleteConfirmation = (): [TConfirmDeleteFunc, ReactElement] => {
  const [modal, contextHolder] = Modal.useModal();

  const confirmDelete = useCallback(
    (
      resourceName: string,
      onOk: () => void,
      okText: string = 'OK',
      cancelText: string = 'Cancel'
    ) => {
      modal.confirm({
        title: (
          <span>
            Are you sure you want to delete <b>{resourceName}</b>?
          </span>
        ),
        icon: <Icon id="ExclamationCircleOutlined" alt="Exclamation Circle" />,
        okText,
        cancelText,
        onOk,
      });
    },
    [modal]
  );

  return [confirmDelete, contextHolder];
};
